import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { USER_INFO } from "constants/AuthConstant";
import DashboardService from "services/DashboardService";

export const initialState = {
  loading: false,
  hrAssessments: [],
  technicalAssessments: [],
  technicalAssessment: [],
  pendingHRJobOffers: [],
  pendingCandidateJobOffers: [],
  pendingInterviews: [],
  interviews: [],
  candidates: [],
  agencies: [],
  candidateCount: 0,
  agencyCount: 0,
  applications: [],
  vacancies: [],
};

export const GetDashboard = createAsyncThunk(
  "/Dashboard/HRDashboard",
  async (data, { rejectWithValue }) => {
    try {
      const userInfo = JSON.parse(localStorage.getItem(USER_INFO));

      let response;
      if (userInfo.role === "HR Manager") {
        response = await DashboardService.GetHRDashboard();
      } else if (userInfo.role === "Agency") {
        response = await DashboardService.GetAgencyDashboard({
          agencyId: userInfo.agencyId,
        });
      } else if (userInfo.role === "Candidate") {
        response = await DashboardService.GetCandidateDashboard({
          candidateId: userInfo.candidateId,
          nationalityId: userInfo.nationalityId,
        });
      } else if (userInfo.role === "Admin") {
      } else if (userInfo.role === "Recruiter") {
        response = await DashboardService.GetRecruiterDashboard({
          candidateId: userInfo.candidateId,
        });
      } else if (userInfo.role === "HR Assessment") {
        response = await DashboardService.GetHRAssessment({
          userId: userInfo.id,
        });
      } else if (userInfo.role === "Technical Assessment") {
        response = await DashboardService.GetAssessmentDashboard({
          userId: userInfo.id,
        });
      } else {
        response = await DashboardService.GetRecruiterDashboard();
      }

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetDashboard.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDashboard.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.hrAssessments = payload.hrAssessments;
        state.technicalAssessments = payload.technicalAssessments;
        state.pendingHRJobOffers = payload.pendingHRJobOffers;
        state.pendingCandidateJobOffers = payload.pendingCandidateJobOffers;
        state.pendingInterviews = payload.pendingInterviews;
        state.interviews = payload.interviews;
        state.candidates = payload.candidates;
        state.agencies = payload.agencies;
        state.candidateCount = payload.candidateCount;
        state.agencyCount = payload.agencyCount;
        state.vacancies = payload.vacancyDahboards || payload.vacancies;
        state.applications = payload.applications;
      })
      .addCase(GetDashboard.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
